import { useEffect } from 'react';
import NowSection from '../sections/NowSection';

export default function NowPage() {
  useEffect(() => {
    document.title = 'Now – Zen Zalapski';
  }, []);

  return (
    <main className="main-content">
      <NowSection />
    </main>
  );
}
